import LocalStorageAdapter from 'shared/localstorage_adapter.js';
import AhoyTracker from 'shared/ahoy_tracker';

export default class LoginOffering {
  constructor() {
    this.$element = $('.js-login-offering');
    this.localStorageKey = 'login-offering-watch-count';
    this.maxWatchCount = 4;
    this.ahoy = this.$element.length > 0 ? new AhoyTracker(this.$element[0]) : false;
  }

  show() {
    if(this.$element.length == 0) {
      return;
    }

    if (this.$element.data('isShowed')) { return }

    let watchCount = this.incrementWatchCount();
    if (watchCount >= this.maxWatchCount) {
      this.$element.find('.js-login-offering__close').on('click', this.close.bind(this));
      this.$element.removeClass('hide');
      this.$element.data('isShowed', true);

      this.sendAhoyImpressionEvent();

      this.resetWatchCount();
    }
  }

  close(e) {
    e.preventDefault();
    this.$element.addClass('hide');
  }

  incrementWatchCount() {
    let watchCount = parseInt(LocalStorageAdapter.getItem(this.localStorageKey));
    if (isNaN(watchCount)) { watchCount = 0; }

    LocalStorageAdapter.setItem(this.localStorageKey, ++watchCount);

    return watchCount;
  }

  resetWatchCount() {
    LocalStorageAdapter.removeItem(this.localStorageKey);
  }

  sendAhoyImpressionEvent() {
    this.ahoy.sendEventImpression();
  }
}
